import { IEventParticipant, IPromoTeam } from '@incentivegames/ig-types/lib/interfaces/apiContracts';
import { IDecisionTimeCard } from 'components/Pages/DecisionTime';

export const decisionTimeCardsTest: IDecisionTimeCard[] = [
  {
    playerName: 'Ayoze Pérez',
    selectionNumber: '1',
    teamCode: 'LEI',
    homeTeamCode: 'LEI',
    awayTeamCode: 'NEW',
    formattedDate: 'Oct 10, 3PM',
    position: 'MID',
    playerNo: 14,
    team: 'leicester'
  },
  {
    playerName: 'Yeldin',
    selectionNumber: '1',
    teamCode: 'LEI',
    homeTeamCode: 'LEI',
    awayTeamCode: 'NEW',
    formattedDate: 'Oct 10, 3PM',
    position: 'MID',
    playerNo: 14,
    team: 'leicester'
  }
];

const devEventParticipant: IEventParticipant = {
  participantId: 123,
  participantName: '',
  colourCode: '',
  participantCode: 'TOT',
  position: 0
};

export const devPromoTeam: IPromoTeam = {
  teamNumber: 1,
  teamName: '',
  team: [
    {
      selnNumber: 1,
      teamMemberId: 1,
      eventId: 1234,
      teamCode: 'TOT',
      firstName: 'Harry',
      lastName: 'Kane',
      displayName: 'Kane',
      shirtNumber: '9',
      position: 'st',
      points: 0,
      returns: 0,
      revealTime: 0,
      expiryTime: 0,
      eventStartTime: new Date(2021, 9, 10, 15).getTime(),
      eventParticipants: [
        { ...devEventParticipant, participantCode: 'TOT' },
        { ...devEventParticipant, participantCode: 'LIV' }
      ],
      revealed: true,
      teamName: 'Tottenham'
    },
    {
      selnNumber: 2,
      teamMemberId: 2,
      eventId: 1234,
      teamCode: 'LIV',
      firstName: 'Mohamed',
      lastName: 'Salah',
      displayName: 'Salah',
      shirtNumber: '10',
      position: 'st',
      points: 0,
      returns: 0,
      revealTime: 0,
      expiryTime: 0,
      eventStartTime: new Date(2021, 9, 10, 11).getTime(),
      eventParticipants: [
        { ...devEventParticipant, participantCode: 'LIV' },
        { ...devEventParticipant, participantCode: 'TOT' }
      ],
      revealed: true,
      teamName: 'Liverpool'
    },
    {
      selnNumber: 3,
      teamMemberId: 3,
      eventId: 1234,
      teamCode: 'MUN',
      firstName: 'Bruno',
      lastName: 'Fernandes',
      displayName: 'Fernandes',
      shirtNumber: '11',
      position: 'st',
      points: 0,
      returns: 0,
      revealTime: 0,
      expiryTime: 0,
      eventStartTime: new Date(2021, 9, 10, 15).getTime(),
      eventParticipants: [
        { ...devEventParticipant, participantCode: 'LIV' },
        { ...devEventParticipant, participantCode: 'MUN' }
      ],
      revealed: true,
      teamName: 'Man United'
    },
    {
      selnNumber: 4,
      teamMemberId: 4,
      eventId: 1234,
      teamCode: 'TOT',
      firstName: 'Son',
      lastName: 'Heung-Min',
      displayName: 'Heung-Min',
      shirtNumber: '7',
      position: 'st',
      points: 0,
      returns: 0,
      revealTime: 0,
      expiryTime: 0,
      eventStartTime: new Date(2021, 9, 10, 13).getTime(),
      eventParticipants: [
        { ...devEventParticipant, participantCode: 'TOT' },
        { ...devEventParticipant, participantCode: 'LIV' }
      ],
      revealed: false,
      teamName: 'Tottenham'
    },
    {
      selnNumber: 5,
      teamMemberId: 5,
      eventId: 1234,
      teamCode: 'MUN',
      firstName: 'Rashford',
      lastName: 'Marcus',
      displayName: 'Rashford',
      shirtNumber: '11',
      position: 'st',
      points: 0,
      returns: 0,
      revealTime: 0,
      expiryTime: 0,
      eventStartTime: new Date(2021, 9, 12, 15).getTime(),
      eventParticipants: [
        { ...devEventParticipant, participantCode: 'MUN' },
        { ...devEventParticipant, participantCode: 'LIV' }
      ],
      revealed: false,
      teamName: 'Man United'
    }
  ]
};
